import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { getTranslations, getProject, getProjectBase64 } from '@lib/api';
import { Redirect } from 'react-router-dom';
import GeneralDataDetails from './components/generalDataDetails';
import ESGDetails from './components/esgDetails';
import SroiDetails from './components/sroiDetails';
import ProjectHeader from '@components/project/ProjectHeader';
import MonitoringSelector from 'components/monitoring/MonitoringSelector';

function isNumber(str) {
  return !isNaN(str) && !isNaN(parseFloat(str));
}

function isBase64Encoded(str) {
  if (isNumber(str)) return;
  if (typeof str !== 'string' || str.length % 4 !== 0 || /[^A-Za-z0-9+/=]/.test(str)) {
    return false;
  }

  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
}

const DashboardMonitoraggioProgetto = (props) => {
  const { projectId, reportNumber } = props.match.params;
  const [isMounted, setIsMounted] = useState(true);
  const history = useHistory();
  const [translations, setTranslations] = useState([]);
  const [project, setProject] = useState({});
  const [monitoredProject, setMonitoredProject] = useState({});
  const [selectedProjectVersion, setSelectedProjectVersion] = useState(null);
  const [isInDetails, setIsInDetails] = useState('general');
  const printRef = React.useRef();
  const [showCells, setShowCells] = useState(false);

  useEffect(() => {
    if (!isBase64Encoded(projectId) && !reportNumber) {
      if (isMounted) {
        getTranslations().then((retrievedTranslation) => {
          setTranslations(retrievedTranslation);
        });
        // CHIEDERE A DOM COME RICEVERE LA VERSIONE ULTIMA DI MONITORAGGIO PER RISALIRE A QUELLA PRECEDENTE
        getProject(projectId).then((retrievedProject) => {
          setSelectedProjectVersion(retrievedProject?.ver);
        });

        setIsInDetails(props.location.pathname === `/progetti/${projectId}` ? true : false);
      }
    }

    if (props.match.path.includes('projectresults')) {
      if (!isBase64Encoded(projectId) || !isBase64Encoded(reportNumber)) {
        history.push('/progetti');
      } else if (isBase64Encoded(projectId) && isBase64Encoded(reportNumber)) {
        if (isMounted) {
          getTranslations().then((retrievedTranslation) => {
            setTranslations(retrievedTranslation);
          });
          getProjectBase64(reportNumber, projectId).then((retrievedProject) => {
            if (!retrievedProject?.code) {
              setProject(retrievedProject);
            } else if (retrievedProject?.code === 418) {
              history.push('/progetti');
            }
          });

          setIsInDetails(
            props.location.pathname === `/projectresults/${projectId}/${reportNumber}`
              ? true
              : false,
          );
        }
      }
    }

    // if (isBase64Encoded(projectId)) {
    //   getTranslations().then((retrievedTranslation) => {
    //     setTranslations(retrievedTranslation);
    //   });

    //   getProjectBase64(reportNumber, projectId).then((retrievedProject) => {
    //     setProject(retrievedProject);
    //   });

    //   setIsInDetails(
    //     props.location.pathname === `/projectresults/${projectId}/${reportNumber}` ? true : false
    //   );
    // }
    return () => {
      setIsMounted(false);
    };
  }, [projectId, reportNumber, props.location.pathname, props.match.path, history, isMounted]);

  useEffect(() => {
    if (!selectedProjectVersion) return;

    getProject(projectId, selectedProjectVersion - 1).then((retrievedMonitoredProject) => {
      setProject(retrievedMonitoredProject);
    });

    getProject(projectId, selectedProjectVersion).then((retrievedProject) => {
      setMonitoredProject(retrievedProject);
    });
  }, [selectedProjectVersion, projectId]);

  if (!projectId || !project) return <Redirect to='/progetti' />;
  return (
    <div id='dashboard' ref={printRef} className='megaContent'>
      {project?.id && (
        <div className='container-fluid'>
          <ProjectHeader
            project={project}
            isInDetails={isInDetails}
            translations={translations}
            printRef={printRef}
            setShowCells={setShowCells}
          />
          <MonitoringSelector
            projectId={project.id}
            versionId={project?.ver}
            projectLastVersion={project?.ver}
            isInDashboard={true}
            state={selectedProjectVersion}
            setState={setSelectedProjectVersion}
          />
          {(project.sectorCode || project.interventionClassCode) &&
          (project.sectorCode === 'EVENTI' || project.interventionClassCode === 'NOINTPURCH') ? (
            <GeneralDataDetails
              className='mb-5'
              currentProject={project}
              sectorCode={project.sectorCode}
              proponentCode={project.proponentCode}
              translations={translations}
            />
          ) : (
            <>
              <Row className='gap-1 mb-4'>
                <Col>
                  <GeneralDataDetails
                    className='mb-5'
                    currentProject={project}
                    sectorCode={project.sectorCode}
                    proponentCode={project.proponentCode}
                    translations={translations}
                  />
                </Col>

                {/* <Col xs={4}>
                  <SroiDetails
                    className='mb-5'
                    currentProject={project}
                    sectorCode={project.sectorCode}
                    proponentCode={project.proponentCode}
                  />
                </Col> */}
              </Row>
            </>
          )}

          <Row className=''>
            <Col>
              <SroiDetails
                className='mb-5'
                currentProject={project}
                monitoredProject={monitoredProject}
                sectorCode={project?.sectorCode}
                proponentCode={project?.proponentCode}
                selectedProjectVersion={selectedProjectVersion}
              />
            </Col>

            {/* <Col>
              <SroiDetails
                className='mb-5'
                currentProject={monitoredProject}
                sectorCode={project.sectorCode}
                proponentCode={project.proponentCode}
              />
            </Col> */}
          </Row>
          <ESGDetails project={project} compareProject={monitoredProject} />
        </div>
      )}
    </div>
  );
};

export default DashboardMonitoraggioProgetto;
